Object.defineProperty(exports, "__esModule", {
  value: true
});
var dateFormats = {
  date: 'yyyy-MM-dd',
  basic_date: 'yyyyMMdd',
  basic_date_time: "yyyyMMdd'T'HHmmss.fffzzz",
  basic_date_time_no_millis: "yyyyMMdd'T'HHmmsszzz",
  date_time_no_millis: "yyyy-MM-dd'T'HH:mm:sszzz",
  basic_time: 'HHmmss.fffzzz',
  basic_time_no_millis: 'HHmmsszzz',
  epoch_millis: 'epoch_millis',
  epoch_second: 'epoch_second'
};
exports.default = dateFormats;